import { render, staticRenderFns } from "./KvmDockerTemplates.vue?vue&type=template&id=01b99940&scoped=true&"
import script from "./KvmDockerTemplates.vue?vue&type=script&lang=js&"
export * from "./KvmDockerTemplates.vue?vue&type=script&lang=js&"
import style0 from "./KvmDockerTemplates.vue?vue&type=style&index=0&id=01b99940&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b99940",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b99940')) {
      api.createRecord('01b99940', component.options)
    } else {
      api.reload('01b99940', component.options)
    }
    module.hot.accept("./KvmDockerTemplates.vue?vue&type=template&id=01b99940&scoped=true&", function () {
      api.rerender('01b99940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmDockerTemplates.vue"
export default component.exports